import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="9.5" cy="11" rx="9.5" ry="9" fill="#CE8C0C" />
    <circle cx="9.5" cy="9.5" r="9.5" fill="url(#paint0_linear_1964_314)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 16.4333C13.3292 16.4333 16.4333 13.3292 16.4333 9.5C16.4333 5.67083 13.3292 2.56667 9.5 2.56667C5.67083 2.56667 2.56667 5.67083 2.56667 9.5C2.56667 13.3292 5.67083 16.4333 9.5 16.4333ZM9.5 17.5C13.9183 17.5 17.5 13.9183 17.5 9.5C17.5 5.08172 13.9183 1.5 9.5 1.5C5.08172 1.5 1.5 5.08172 1.5 9.5C1.5 13.9183 5.08172 17.5 9.5 17.5Z"
      fill="#E2AB1A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4333 9.5C16.4333 4.7 12.3894 2.86822 11.3667 2.3C10.344 1.73178 9.5 1.5 9.5 1.5C13.9183 1.5 17.5 5.08172 17.5 9.5C17.5 13.9183 13.9183 17.5 9.5 17.5C9.5 17.5 9.76693 17.4956 11.3667 16.9667C12.9664 16.4377 16.4333 13.3292 16.4333 9.5Z"
      fill="#D89C00"
    />
    <path
      d="M9.13173 13C8.18994 13 7.28325 12.7555 6.48229 12.2233C5.92399 11.8524 5.27783 11.015 5.27783 9.59536C5.27783 6.96158 6.67931 6.00034 9.49569 6.00034L13.5425 6.00034C13.5425 6.00034 13.6672 5.99421 13.7025 6.03404C13.747 6.08418 13.7025 6.20269 13.7025 6.20269L13.3217 7.32404C13.3217 7.32404 13.2713 7.4283 13.2189 7.46231C13.1577 7.5021 13.0581 7.50045 13.0581 7.50045H9.88209C8.02323 7.50045 6.91792 7.63961 6.91792 9.59536C6.91792 10.2414 7.10769 10.7011 7.49828 11.0007C8.15841 11.507 9.44149 11.5285 10.2255 11.456C10.2255 11.456 10.5472 10.463 10.6002 10.3018C10.6622 10.1129 10.635 10.0678 10.4415 10.0678C10.1618 10.0678 9.65919 10.0678 9.1257 10.0678C8.75182 10.0678 8.38451 9.88722 8.38451 9.45335C8.38451 9.03435 8.72625 8.79115 9.19471 8.79115C10.0058 8.79115 11.6764 8.79115 11.989 8.79115C12.3989 8.79115 12.8172 8.84757 12.6038 9.47049L11.4736 12.761C11.4736 12.761 10.5502 13 9.13173 13Z"
      fill="#E2A60B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1964_314"
        x1="9.5"
        y1="0"
        x2="9.5"
        y2="19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEDC28" />
        <stop offset="1" stopColor="#F1C34B" />
      </linearGradient>
    </defs>
  </SvgIcon>
));
